module.exports = __webpack_public_path__ + "img/3.07.thmb.7dbe21ba.jpg";